import React from "react";
import { ServicesSec } from "../ui/services-sec";

export const Services = () => (
  <>
    <ServicesSec />
  </>
);
